import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { Transition } from '@uirouter/angular';
import { omit } from 'lodash-es';

import { GraphQlService, TrainerService } from '../../../_services';
import {
    TrainerQueryOutput,
    TrainerMutationInput,
} from './models/trainer.model';
import { ToasterService } from '../../_shared/toaster';

@Component({
    selector: 'trainer-detail',
    templateUrl: './detail.component.html',
    styleUrls: ['../trainer.component.scss', './detail.component.scss'],
    providers: [TranslatePipe],
})
export class TrainerDetailComponent implements OnInit {
    private static _active: string;

    error: string;
    success: string;
    account: any;
    currentTrainer: TrainerQueryOutput;
    languages: string[];

    constructor(
        private translateService: TranslateService,
        private toasterService: ToasterService,
        private graphqlService: GraphQlService,
        private trainerService: TrainerService,
        private trans: Transition
    ) {}

    get active(): string {
        return TrainerDetailComponent._active;
    }

    set active(active: string) {
        TrainerDetailComponent._active = active;
    }

    ngOnInit() {
        this.load(this.trans.params()['id']);
        this.active = 'experience';
    }

    load(id) {
        this.graphqlService
            .post({
                query: `
                    query($id: bigint!) {
                        languages: language {
                            code
                        }
                        trainer: trainer_by_pk(id: $id) {
                            phone
                            active
                            address1
                            address2
                            bio
                            city
                            companyId: company_id
                            company {
                                name
                            }
                            countryCode: country_code
                            email
                            firstName: first_name
                            id
                            interne
                            job
                            lastName: last_name
                            title
                            zipCode: zip_code
                            trainerLanguages: trainer_languages {
                                code: language_code
                            }
                            trainerSkills: plt_trainer_skills {
                                id
                                nbGiven: nb_given
                                followed
                                wished
                                can
                                refuse
                                training {
                                    title
                                }
                            }
                        }
                    }
                `,
                variables: {
                    id,
                },
                role: 'world',
            })
            .subscribe(({ trainer, languages }) => {
                this.currentTrainer = trainer;
                this.languages = languages;
            });
    }

    onTrainerSaved(trainer: TrainerMutationInput) {
        this.graphqlService
            .post({
                query: `
                mutation(
                    $id: bigint,
                    $trainer: trainer_set_input!
                    $languages: [trainer_language_insert_input!]!
                ) {
                    delete_trainer_language(where: {trainer_id: {_eq: $id}}) {
                        affected_rows
                    }
                    insert_trainer_language(objects: $languages) {
                        affected_rows
                    }
                    updateTrainer: update_trainer(
                        _set: $trainer
                        where: { id: { _eq: $id } }
                    ) {
                        returning {
                            id
                        }
                    }
                }`,
                variables: {
                    id: trainer.id,
                    trainer: omit(trainer, ['id', 'trainer_languages']),
                    languages: trainer.trainer_languages.data.map(
                        ({ language_code }) => ({
                            trainer_id: trainer.id,
                            language_code,
                        })
                    ),
                },
            })
            .subscribe(({ updateTrainer }) => {
                if (
                    updateTrainer &&
                    updateTrainer.returning[0] &&
                    updateTrainer.returning[0].id === this.currentTrainer.id
                ) {
                    this.toasterService.success(
                        this.translateService.instant(
                            'trainer-detail.update-success-message'
                        )
                    );
                }
            });
    }
    toggleTab(selectedTab) {
        this.active = selectedTab;
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/trainer/detail/detail.component.ts